import { render, staticRenderFns } from "./MPStatus.vue?vue&type=template&id=34911506&"
import script from "./MPStatus.vue?vue&type=script&lang=js&"
export * from "./MPStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports